import { InjectionToken } from '@angular/core';

export const BASE_URL_PROVIDER = new InjectionToken<string>('Base url provider');
